<template>
  <v-card class="import-section">
    <v-card-title class="justify-center">
      Upload Section 00
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('volume.cover_pdf') }}
          </v-col>
          <v-col cols="9">
            <FileInput v-model="pdfFile"
                       accept="application/pdf"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'ImportVolumeCoverPdfDialog',
  components: {FileInput},
  props: {
    volumeId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);

    const pdfFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('volume_id', props.volumeId);
      formData.append('cover', pdfFile.value, pdfFile.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/volume/upload_cover/',
        params: formData,
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    return {
      requiredRules,

      pdfFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.import-section {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
